<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-title1"><a id="page_5">CONTENTS</a></p><a id="page_5">
<table cellspacing="0" class="source-table" width="100%">
<tbody>
<tr>
<td align="left" valign="top"><a href="#/xhtml/acknow">Acknowledgements</a></td>
<td align="left" valign="top"> </td>
</tr>
<tr>
<td align="left" valign="top"><a href="#/xhtml/intro">Introduction</a></td>
<td align="left" valign="top"> </td>
</tr>
<tr>
<td align="left" valign="top"><a href="#/xhtml/prologue">Prologue</a></td>
<td align="left" valign="top"> </td>
</tr>
<tr>
<td align="left" valign="top"><a href="#/xhtml/ch01">Chapter 1</a></td>
<td align="left" valign="top"><a href="#/xhtml/ch01">Over to the Offensive</a></td>
</tr>
<tr>
<td align="left" valign="top"><a href="#/xhtml/ch02">Chapter 2</a></td>
<td align="left" valign="top"><a href="#/xhtml/ch02">Night Defenders</a></td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/ch03" title="Link target outside of Sample">Chapter 3</span></td>
<td align="left" valign="top"><span href="#/xhtml/ch03" title="Link target outside of Sample">Shipping Strikes</span></td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/ch04" title="Link target outside of Sample">Chapter 4</span></td>
<td align="left" valign="top"><span href="#/xhtml/ch04" title="Link target outside of Sample">Rangers and Ramrods</span></td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/ch05" title="Link target outside of Sample">Chapter 5</span></td>
<td align="left" valign="top"><span href="#/xhtml/ch05" title="Link target outside of Sample">D-Day Air Power</span></td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/ch06" title="Link target outside of Sample">Chapter 6</span></td>
<td align="left" valign="top"><span href="#/xhtml/ch06" title="Link target outside of Sample">Attack and Defence</span></td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/ch07" title="Link target outside of Sample">Chapter 7</span></td>
<td align="left" valign="top"><span href="#/xhtml/ch07" title="Link target outside of Sample">Operating from France</span></td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/ch08" title="Link target outside of Sample">Chapter 8</span></td>
<td align="left" valign="top"><span href="#/xhtml/ch08" title="Link target outside of Sample">‘The Unequal Combat is Nearing its End’</span></td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/ch09" title="Link target outside of Sample">Chapter 9</span></td>
<td align="left" valign="top"><span href="#/xhtml/ch09" title="Link target outside of Sample">Loss of an Ace</span></td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/ch10" title="Link target outside of Sample">Chapter 10</span></td>
<td align="left" valign="top"><span href="#/xhtml/ch10" title="Link target outside of Sample">Jets, V2s and Airborne Assaults</span></td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/ch11" title="Link target outside of Sample">Chapter 11</span></td>
<td align="left" valign="top"><span href="#/xhtml/ch11" title="Link target outside of Sample">The Ardennes and the Luftwaffe’s Last Show</span></td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/ch12" title="Link target outside of Sample">Chapter 12</span></td>
<td align="left" valign="top"><span href="#/xhtml/ch12" title="Link target outside of Sample">Victory</span></td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/app1" title="Link target outside of Sample">Appendix 1</span></td>
<td align="left" valign="top"> </td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/app2" title="Link target outside of Sample">Appendix 2</span></td>
<td align="left" valign="top"> </td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/source" title="Link target outside of Sample">Primary Sources</span></td>
<td align="left" valign="top"> </td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/biblio" title="Link target outside of Sample">Bibliography</span></td>
<td align="left" valign="top"> </td>
</tr>
<tr>
<td align="left" valign="top"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></td>
<td align="left" valign="top"> </td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?29721bf8